import CampaignCard from './components/CampaignCard';
import { PaginationInfo } from 'models/PaginatedData';
import useCampaigns from './hooks/useCampaigns';
import useQueryParams from 'hooks/useQueryParams';
import { BlockUI, Pagination, SkeletonCard } from 'components';
import { CampaignTabs } from './components';

import './Campaigns.styles.scss';

const Campaigns = () => {
  const { params } = useQueryParams();

  const { data: campaignsData, isLoading } = useCampaigns(params);

  const { items, ...rest } = campaignsData || {};

  return (
    <div className="campaigns-page">
      <div className="campaigns-page__container">
        <CampaignTabs />
        <BlockUI
          loading={isLoading}
          loadingElement={
            <>
              <SkeletonCard className="campaigns-page__skeleton" />
              <SkeletonCard className="campaigns-page__skeleton" />
              <SkeletonCard className="campaigns-page__skeleton" />
            </>
          }
        >
          {!!items && (
            <div className="campaigns-list">
              {items?.length === 0 && <div>No campaings found.</div>}
              {items?.map((campaign) => (
                <CampaignCard key={campaign.id} campaign={campaign} />
              ))}
            </div>
          )}
          {!!campaignsData && (
            <Pagination pagination={rest as PaginationInfo} />
          )}
        </BlockUI>
      </div>
    </div>
  );
};

export default Campaigns;
